import React, { Component } from 'react'
import axios from '../utils/axiosWrapper'

export const Context = React.createContext()

class Provider extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoaded: false,
      token: undefined,
      userData: undefined,
    }
  }

  fetch = async (method, url, data, headers, config) => {
    const { token } = this.state
    const response = await axios({
      method,
      url,
      data,
      headers: token ? { ...headers, Authorization: `JWT ${token}` } : headers,
      ...config,
    })
      .then(res => {
        if (process.env.NODE_ENV === 'development') {
          // console.log('fetch res', res.data)
        }
        return { data: res.data, success: true }
      })
      .catch(err => {
        // TODO 401 log out (only if token exists)
        // TODO catch timeout error
        if (process.env.NODE_ENV === 'development') {
          // console.error('fetch err', err.response && err.response.data ? err.response.data : err.response)
        }
        return { data: err.response && err.response.data, success: false }
      })
    return response
  }

  login = async (username, password) => {
    const tokenRes = await this.fetch('post', '/api-token-auth/', { username, password })
    if (tokenRes.success) {
      this.setState({ token: tokenRes.data.token }, async () => {
        const userRes = await this.fetch('get', `/api/users/`)
        if (userRes.success) {
          this.setState({ userData: userRes.data[0] })
        } else {
          console.error(userRes) // TODO error
        }
      })
      return { success: true }
    }
    return { success: false }
  }

  logout = async () => {
    console.log('logout')
    const res = await this.fetch('get', `/logout`)
    if (res.success) {
      this.setState({ token: undefined, userData: undefined })
    } else {
      alert('logout failed')
    }
  }

  render() {
    const { children } = this.props
    const { userData, isLoaded } = this.state
    return (
      <Context.Provider
        value={{
          userData,
          isLoaded,
          login: this.login,
          logout: this.logout,
          fetch: this.fetch,
        }}
      >
        {children}
      </Context.Provider>
    )
  }
}

export default Provider
